import { useSelector } from 'react-redux'
import get from 'lodash/get'

const usePermissions = permission => {
  const permissions = useSelector(state => get(state, 'account.permissions'))

  if (!permission) return true
  if (!permissions) return false

  let hasPermission = false

  if (Array.isArray(permission)) {
    hasPermission = permission.some(p => permissions.includes(p))
  } else {
    hasPermission = permissions.includes(permission)
  }
  return hasPermission
}

export default usePermissions
